import { GridSizeChangedEventArgs as GridSizeChangedEventArgs_internal } from "./GridSizeChangedEventArgs";
/**
 * Event arguments for the SizeChanged event.
*/
var IgrGridSizeChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridSizeChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridSizeChangedEventArgs.prototype.createImplementation = function () {
        return new GridSizeChangedEventArgs_internal();
    };
    Object.defineProperty(IgrGridSizeChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridSizeChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridSizeChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridSizeChangedEventArgs.prototype, "width", {
        /**
         * The new width.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridSizeChangedEventArgs.prototype, "height", {
        /**
         * The new height.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridSizeChangedEventArgs;
}());
export { IgrGridSizeChangedEventArgs };
//# sourceMappingURL=igr-grid-size-changed-event-args.js.map
